<div class="balance-tile">
    <div class="section-label section-label--light balance-tile-label">
        {{ label }}
        @if (tooltipText) {
            <i [attr.aria-label]="label + ': ' + tooltipText"
               [pTooltip]="tooltipText"
               class="fa fa-info-circle balance-tile-info"
               infoTip></i>
        }
    </div>
    <div class="balance-tile-value" [class.empty]="empty">
        @if (unavailable) {
            <span class="data-unavailable data-unavailable--light">{{ unavailableText }}</span>
        } @else {
            {{ value }}
        }
    </div>
    @if (description) {
        <div class="balance-tile-description">{{ description }}</div>
    }
</div>
